package de.oevbs.kunde.kundenportal2.model.services.delivery

import de.oevbs.businesspartner.bpcrmservice2.partner.model.Dispatch
import dev.fritz2.core.Lenses
import kotlinx.serialization.Serializable

@Lenses
@Serializable
data class Delivery(
    val currentOption: Dispatch = Dispatch.Post,  // Wenn keine Angabe vorliegt, dann immer "Post"
    val crmMailAddress: String = ""
) { companion object }

